import React, {useState, useEffect} from "react";
import Form from "psx-form";
import axios from "axios";
import yaml from "js-yaml";
import './css/Main.scss';

export default function App(props) {
	const [data, setData] = useState(null);
	const [errors, setErrors] = useState(null);
	const [disabled, setDisabled] = useState(null);
	const [result, setResult] = useState(null);
	const [success, setSuccess] = useState(null);

	let api = axios.create({
		baseURL: `v1/`,
	});

	useEffect(() => {
					var queryString = window.location.search
			let params = new URLSearchParams(queryString);
		api.get('form/definition?path=' + params.get('f')).then(res => {
			if (res && res.data) {
				let parsed = yaml.load(res.data);
				setData(parsed);
				if (parsed.css) {
					var styleSheet = document.createElement("style");
					styleSheet.innerText = parsed.css.replace(/[<]br[^>]*[>]/gi,"");
					document.head.appendChild(styleSheet);
				}
			}
		});
	}, []);

	useEffect(() => {
		if (data && data.pageTitle) {
			document.title = data.pageTitle;
		}
	}, [data]);

	const onSubmit = (form) => {
		setErrors(null);
		setDisabled(true);
		let formData = new FormData();
		formData['type'] = data.definition;
		formData.append("type", data.definition);
		Object.entries(form).forEach(([key, value]) => {
			if (value instanceof FileList) {
				if(value.length > 0){
				formData.append(key, value[0]);
			}
			} else if(Array.isArray(value)){
				let values = [];
				value.forEach(o=>	values.push(o.value));				
				formData.append(key, JSON.stringify(values));
			} else if (value instanceof Object) {
				formData.append(key, value.value);
			} else if(value !== undefined){
				formData.append(key, value);
			}
		});
		var queryString = window.location.search
		let params = new URLSearchParams(queryString);
		if (data.urlParams) {
			data.urlParams.forEach(p => {
				let value = params.get(p);
				if (value) {
					formData.append(p, value);
				}
			});
		}
		formData.append('form',params.get('f'));
		api.post('form/submit', formData).catch((error) => {
			setSuccess(false);
			setResult(data.errorMessage ? data.errorMessage : 'Wystąpił błąd.')
		}).then(res => {
			let success = res && res.data && res.data.success;
			setSuccess(success);
			if (success) {
				setResult(data.successMessage ? data.successMessage : 'Wysłano zgłoszenie.')
			} else if(res.data.errors){
				setErrors(res.data.errors);
				if(res.data.errors['form']){
					setResult(res.data.errors['form']);
				}
				setDisabled(false);
			}else {				
				setResult((data.errorMessage ? data.errorMessage.replace("{errorId}", (res && res.data ? res.data.errorId : "")) : 'Wystąpił błąd. Kod błędu: ' + (res && res.data ? res.data.errorId : "")))
				setDisabled(false);
			}
		});
	}
	let resultHtml = result && ('<div class="result ' + (success ? "success" : "failed") + '">' + result + '</div>');
	let processingMessage = null;
	if(disabled && !success){
		processingMessage	= data.processingMessage ? data.processingMessage : 'Przetwarzanie. Proszę czekać';
	}
	return (<React.Fragment>
		{data && <Form data={data} onSubmit={onSubmit} disabledSubmit={disabled} submitTitle={data.submitTitle} success={success} processingMessage={processingMessage}
									 result={resultHtml} hideForm={result && success && data.hideFormOnSuccess} errors={errors}></Form>}
	</React.Fragment>
					);
}